<template lang="pug">
section.project-list-panel(:class="inSharePanel ? 'in-share-panel' : 'no-share-panel'")
  .asu-title.div-aux-to-fixed-header(v-if="!inSharePanel")
    span Proyectos
  div.center(v-show="isLoading")
    md-progress-spinner(md-mode="indeterminate")
  div(v-show="!isLoading")
    v-list
      template(v-for="(item, i) in projects")
        v-list-tile.project-item(
          ripple
          @mouseover="hoverProject(item)"
          @mouseout="unHoverProject(item)"
          @click.stop="selectProjectInfo(item)"
          :class="isSelected(item) ? 'selected': ''"
        )
          v-list-tile-avatar
            span.project-number {{item.number}}
          v-list-tile-content
            v-list-tile-title
              span.project-name {{item.name}}
          v-list-tile-action
            i.material-icons.project-button-icon keyboard_arrow_right
        md-divider.md-inset

</template>

<script>
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'ProjectListPanel',
  props: {
    noClose: Boolean,
    inSharePanel: Boolean
  },
  mounted () {
    this.setProjects(this.projectsData)
  },
  data () {
    return {
      projects: []
    }
  },
  methods: {
    ...mapActions([
      'toggle',
      'hoverProject',
      'unHoverProject',
      'showProjectInfo'
    ]),

    selectProjectInfo (project) {
      this.$emit('selectProject', project)
      if (this.inSharePanel) return
      this.showProjectInfo(project)
    },

    setProjects ({ projects }) {
      this.projects = projects
    },

    isSelected (item) {
      return (this.getHoverProject && this.getHoverProject.number === item.number) || (this.getProjectInfo && this.getProjectInfo.number === item.number)
    }
  },
  computed: {
    ...mapGetters(['getHoverProject', 'getProjectInfo']),
    ...mapGetters({
      projectsData: 'data',
      isLoading: 'httpIsProcessing'
    })
  },
  watch: {
    projectsData (data) {
      this.setProjects(data)
    }
  }
}
</script>

<style scoped lang="stylus">
@import '~@/styles/variables'

$project-number-padding = .5rem
$project-number-width = 2.4rem
$project-button-icon-width = 1rem

$title-padding = $f10px
$div-aux-to-fixed-header = ($f34px + $title-padding)

.selected .v-list-tile-container
  font-weight: bold

.isMobile .project-list-panel
  height: 80vh
  overflow: auto
  @media screen and (max-width: 768px)
    height: 100% !important;

.project-list-panel
  background-color: white
  border-radius: $f4px
  overflow-y: auto
  .v-list
    box-sizing: border-box
    padding: $f10px
  .asu-title
    padding-bottom: $f7px
    font-size: $f16px
    font-weight: bold
    font-family: 'Roboto Condensed', Roboto
    display: flex
    align-items: center
    justify-content: space-between
    padding: 0 $title-padding 0 $title-padding
    span
      color: $color_0
    .material-icons-button.v-list-action
      color: $color_0
      margin-right: 0px
      & >>> .md-ripple
        padding: 0
.project-name,
.project-number
  display: inline-block
  padding: $f5px $project-number-padding
  white-space: normal
  font-size: $f17px
  vertical-align: middle
  color: $color_0
.project-number
  width: $project-number-width
.project-button-icon
  width: $project-button-icon-width
  &.material-icons
    color: $color_0

// - Estilos para mantener fija la cabecera
.div-aux-to-fixed-header
  height: $div-aux-to-fixed-header
  span
    margin-left: $f20px
    font-size: $f18px
.no-share-panel .v-list
  height: "calc(100vmin - %s)" % 13rem
  height: "calc(100vh - %s)" % 13rem
  overflow-x: hidden
  overflow-y: auto

.project-item >>> .v-list__tile--link
  height: auto
  min-height: 30px
  text-decoration: none

.v-list__tile__content
  display: flex
  align-items: center
  flex-direction: initial
  // Con este se centra los elementos de la lista en IE 11 pero si el contenido necesita crecer más que 48px por el nombre del proyecto muy largo, este no crece y queda en 48 siempre
  // height: 1px
  // min-height: 30px

.v-list__tile__title
  height: auto
  line-height: inherit

</style>
